import { markUiObject as __markUi, translateUi as __ui } from '@/i18n/display'
import {safeAddressText} from './overflowDetail'
import { watch, type App } from 'vue'
import store from '@/store'
import { message } from 'ant-design-vue'
import { copyFullOrderNumber } from './compactList'

export const copyLabel = (text:string):boolean => /^(版型号|款号|货号|成衣型号|订单号|需求号|批次号|快递单号|物流单号|运单号|联系电话|联系人电话|电话号码|手机号码|手机号|收货地址|退货地址|款式链接|款式细节链接|网址|链接)$/.test(text.trim().replace(/[：:]$/, ''))
// 详情区只复制当前已呈现的文字，不访问记录原值，不介入表单或业务按钮。
export function installReadonlyFieldCopies(app:App) {
 const mounted=app.mount.bind(app)
 app.mount=((...args:any[])=>{
  const instance=mounted(...args as [any])
  const root=(typeof args[0]==='string'?document.querySelector(args[0]):args[0]) as HTMLElement
  if(!root)return instance
  const buttons=new Map<HTMLElement,HTMLButtonElement>();let frame=0,stopped=false
  const scan=()=>{
   frame=0;if(stopped)return
   buttons.forEach((button,host)=>{if(!root.contains(host) || button.dataset.phoneCopy==='true' && !store.getters.sysFunctions?.viewCustomerPhoneNumber){button.remove();buttons.delete(host)}})
   root.querySelectorAll<HTMLElement>('.ant-descriptions-item-label').forEach(label=>{
    const name=label.textContent?.trim() || '';if(!copyLabel(name))return
    const phoneLabel=/(电话|手机)/.test(name);if(phoneLabel && !store.getters.sysFunctions?.viewCustomerPhoneNumber)return
    const host=label.nextElementSibling as HTMLElement | null
    if(!host?.classList.contains('ant-descriptions-item-content') || buttons.has(host))return
    if(host.querySelector('input,textarea,select,[contenteditable="true"],.copy-field-button,.copy-order-button,[title^="复制"],[aria-label^="复制"]') || Array.from(host.querySelectorAll('button')).some(button=>button.textContent?.includes('复制')))return
    const text=host.textContent?.trim();if(!text || text==='—')return
    const button=document.createElement('button');button.type='button';button.className='readonly-field-copy';button.textContent='复制';button.title='复制'+name;button.setAttribute('aria-label','复制'+name);button.dataset.phoneCopy=String(phoneLabel)
    button.addEventListener('click',async event=>{
      event.stopPropagation();if(phoneLabel && !store.getters.sysFunctions?.viewCustomerPhoneNumber)return;const clone=host.cloneNode(true) as HTMLElement;clone.querySelectorAll('button').forEach(node=>node.remove());const raw=clone.textContent?.trim() || '';const value=/地址/.test(name)?safeAddressText(raw,Boolean(store.getters.sysFunctions?.viewCustomerPhoneNumber)):raw;if(!value)return
      try{await copyFullOrderNumber(value);message.success(__ui('已复制'))}catch(_){message.error(__ui('复制失败，请手动复制'))}
    })
    host.appendChild(button);buttons.set(host,button)
   })
  }
  const schedule=()=>{if(!stopped && !frame)frame=requestAnimationFrame(scan)}
  const stopPermissionWatch=watch(()=>store.getters.sysFunctions?.viewCustomerPhoneNumber,schedule)
  const observer=new MutationObserver(schedule);observer.observe(root,{subtree:true,childList:true,characterData:true});schedule()
  const unmount=app.unmount.bind(app);app.unmount=()=>{stopped=true;stopPermissionWatch();observer.disconnect();cancelAnimationFrame(frame);buttons.forEach(button=>button.remove());buttons.clear();unmount()}
  return instance
 }) as any
}
